import React from 'react';
import ArticleListByTopic from '../containers/ArticleListByTopic';

const MobileArticleList = () =>
  <div className="mobile-topic-list">
    <ArticleListByTopic />
  </div>;

export default MobileArticleList;



// WEBPACK FOOTER //
// ./home/components/MobileArticleList.js